'use strict';

app.config(function ($popupProvider) {
  $popupProvider.define('avatar', function (avatar) {
    return /*@ngInject*/ {
      backdrop: 'static',
      windowClass: 'avatar-modal-window',
      templateUrl: '/app/states/profile/avatar/avatar.html',
      controller: function ($scope, $q, $timeout, $preloader, $popup, S3Uploader) {

        var SIZE = 360;
        var DEFAULT = '/stubs/users/default.jpg';
        var ready = false;
        var $cropper;

        $scope.url = avatar.url || DEFAULT;
        $scope.zoom = { level: 100 };

        var zoomData = null;

        $scope.$watch('zoom.level', function (zoomLevel, old) {
          if (zoomLevel === old) { return; }
          var scale = 2 - zoomLevel / 100;
          var canvasData = $cropper.cropper('getCanvasData');
          $cropper.cropper('setCanvasData', {
            top: canvasData.top,
            left: canvasData.left,
            width: zoomData.width * scale,
            height: zoomData.height * scale
          });
        });

        $scope.zoomIn = function () {
          if (!ready) { return; }
          $scope.zoom.level = Math.min(100, $scope.zoom.level + 10);
        };

        $scope.zoomOut = function () {
          if (!ready) { return; }
          $scope.zoom.level = Math.max(0, $scope.zoom.level - 10);
        };

        $scope.fitToFrame = function () {
          if (!ready) { return; }
          $scope.zoom = { level: 100 };
        };

        $scope.rotate = function (side) {
          if (!ready) { return; }
          $cropper.cropper('rotate', side == 'left' ? -90 : 90);
          zoomData = {
            width: zoomData.height,
            height: zoomData.width
          };
        };

        $scope.remove = function () {
          if (!ready) { return; }
          $scope.url = DEFAULT;
          ready = false;
          $cropper.cropper('replace', $scope.url);
        };

        $scope.save = function () {
          if (!ready) { return; }
          $q.when()
            .then($preloader.show)
            .then(function () {
              return ($scope.url == DEFAULT) ? null : upload(getBlob());
            })
            .then($scope.$close)
            .finally($preloader.hide);
        };

        $timeout(function () {

          var $modal = $('.avatar-modal-window');

          $cropper = $modal.find('.cropper > img').cropper({
            autoCropArea: 1,
            aspectRatio: 1,
            guides: false,
            highlight: false,
            dragCrop: false,
            mouseWheelZoom: false,
            cropBoxMovable: false,
            cropBoxResizable: false,
            doubleClickToggle: false,
            built: function () {
              var params = { left: 0, top: 0, width: SIZE, height: SIZE };
              $cropper.cropper('zoom', SIZE);
              $cropper.cropper('setCropBoxData', params);
              $cropper.cropper('setCanvasData', params);
              zoomData = $cropper.cropper('getCanvasData');
              ready = true;
              $scope.$apply($scope.fitToFrame);
              $timeout(function () {
                $cropper.parent().css('visibility', '');
              }, 100, false);
            }
          });

          ready = false;
          $cropper.parent().css('visibility', 'hidden');
          $cropper.cropper('replace', $scope.url);

          $modal.find('.uploader').on('change', function () {
            ready = false;
            $cropper.parent().css('visibility', 'hidden');
            var input = this;
            $scope.url = input.value;
            blobToDataURI(input.files[0])
              .then(fixExif)
              .then(function (data) {
                $scope.url = data;
                $cropper.cropper('replace', $scope.url);
                input.value = null;
              });
          });

          $cropper.parent().on('touchend', function () {
            $(this).mouseup();
          });

        }, 200);

        function fixExif (data) {
          return $q(function (resolve) {
            var img = new Image();
            img.addEventListener('load', function () {
              EXIF.getData(img, function () {
                var canvas = document.createElement('canvas');
                var ctx = canvas.getContext('2d');
                var width = img.width;
                var height = img.height;
                var orientation = img.exifdata.Orientation;
                canvas.width  = orientation < 5 ? width  : height;
                canvas.height = orientation < 5 ? height : width;
                switch (orientation) {
                  case 2: ctx.transform(-1,  0,  0,  1,  width,   0);      break;
                  case 3: ctx.transform(-1,  0,  0, -1,  width,   height); break;
                  case 4: ctx.transform( 1,  0,  0, -1,  0,       height); break;
                  case 5: ctx.transform( 0,  1,  1,  0,  0,       0);      break;
                  case 6: ctx.transform( 0,  1, -1,  0,  height,  0);      break;
                  case 7: ctx.transform( 0, -1, -1,  0,  height,  width);  break;
                  case 8: ctx.transform( 0, -1,  1,  0,  0,       width);  break;
                }
                ctx.drawImage(img, 0, 0);
                resolve(canvas.toDataURL());
              });
            });
            img.src = data;
          });
        }

        function getBlob () {
          var params = { width: SIZE, height: SIZE };
          var mime = _.endsWith($scope.url, '.png') ? 'image/png' : 'image/jpeg';
          var data = $cropper.cropper('getCroppedCanvas', params).toDataURL(mime);
          return dataURItoBlob(data);
        }

        function upload (file) {
          var now = Date.now();
          var rand = S3Uploader.randomString(16);
          var ext = file.type == 'image/jpeg' ? 'jpg' : 'png';
          var name = now + '-' + rand + '.' + ext;
          var base;
          return $q.when()
            .then(function () {
              return S3Uploader.getUploadOptions('/api/v1/tools/s3/upload/' + name);
            })
            .then(function (opts) {
              base = 'https://' + opts.bucket + '.s3.amazonaws.com/';
              return S3Uploader.upload($scope.$new(), base, name, opts.acl, file.type, opts.key, opts.policy, opts.signature, file);
            })
            .then(function () {
              return base + name;
            });
        }

        function dataURItoBlob (dataURI) {
          var byteString;
          if (dataURI.split(',')[0].indexOf('base64') >= 0) {
            byteString = atob(dataURI.split(',')[1]);
          } else {
            byteString = unescape(dataURI.split(',')[1]);
          }
          var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
          var ia = new Uint8Array(byteString.length);
          for (var i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
          }
          return new Blob([ia], { type: mimeString });
        }

        function blobToDataURI (file) {
          return $q(function (resolve, reject) {
            var reader = new FileReader();
            reader.onload = function () {
              resolve(reader.result);
            };
            reader.onerror = function () {
              reject(reader.result);
            };
            reader.readAsDataURL(file);
          });
        }

      }
    };
  });
});
